import { render, staticRenderFns } from "./ShopHeaderSearch.vue?vue&type=template&id=bc2275a8"
import script from "./ShopHeaderSearch.vue?vue&type=script&lang=js"
export * from "./ShopHeaderSearch.vue?vue&type=script&lang=js"
import style0 from "./ShopHeaderSearch.vue?vue&type=style&index=0&id=bc2275a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports